import React, { FC } from "react";
import { COLOR_BLACK } from "../colors";
import { IconType } from "./types";

export const ExpandLessIcon: FC<IconType> = ({
  color = COLOR_BLACK,
  size = 24,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 17"
    fill="none"
  >
    <path
      d="M4.94 10.97L8 7.91667L11.06 10.97L12 10.03L8 6.03L4 10.03L4.94 10.97Z"
      fill={color}
    />
  </svg>
);
